import { DataManager } from '@syncfusion/ej2-data';
import { Component, OnInit, ViewChild } from '@angular/core';
import { GridConstantsFactory } from 'src/app/base/shared/syncfusion/grid-constants-factory';
import { DateTime } from 'luxon';
import { FormBuilder } from '@angular/forms';
import { GridComponent, GridModule } from '@syncfusion/ej2-angular-grids';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { AutomaticParkingReportService } from '../automatic-parking-report.service';
import { AutomaticParkingReportParameterDTO, DateRangeParameterDTO } from 'src/app/base/models/models.swagger.generated';
import { SaveOptions } from '../../../reports-footer/save-options';
import { ReportsFooterComponent } from '../../../reports-footer/reports-footer.component';
import { Router } from '@angular/router';
import { reportsRoute } from 'src/app/core/routing/route-names';
import { AutomaticParkingFormGroup, AutomaticParkingFormType } from '../automatic-parking-form/automatic-parking-form.type';
import { TranslateModule } from '@ngx-translate/core';
import { AutomaticParkingFormComponent } from '../automatic-parking-form/automatic-parking-form.component';
import { TitleBarComponent } from '../../../../../base/shared/title-bar/title-bar.component';

@Component({
    selector: 'app-automatic-parking-report',
    templateUrl: './automatic-parking-report.component.html',
    styleUrls: ['./automatic-parking-report.component.scss'],
    imports: [TitleBarComponent, AutomaticParkingFormComponent, GridModule, ReportsFooterComponent, TranslateModule]
})
export class AutomaticParkingReportComponent implements OnInit {
  @ViewChild('grid') public grid: GridComponent;
  @ViewChild(ReportsFooterComponent) public footer: ReportsFooterComponent;

  public data: DataManager;
  public filterForm: AutomaticParkingFormGroup = this.fb.group<AutomaticParkingFormType>({
    startDate: this.fb.control(DateTime.now().startOf('month').toJSDate()),
    endDate: this.fb.control(DateTime.now().endOf('month').toJSDate()),
  });

  public pageSettings = GridConstantsFactory.createStandardPageSettings();

  constructor(private fb: FormBuilder,
              private router: Router,
              private spinnerService: SpinnerService,
              private automaticParkingReportService: AutomaticParkingReportService) { }

  ngOnInit() {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.automaticParkingReportService, this.spinnerService),
    });
    this.searchReports();
  }

  public searchReports(): void {
    if (this.filterForm.controls.startDate.value && this.filterForm.controls.endDate.value) {
      this.automaticParkingReportService.parameters = this.createAutomaticParkingReportParameters();
      try {
        this.grid?.refresh();
      } catch (e) {
        // Ignore error when grid is in transition state
      }
    }
  }

  public saveReport(saveOptions: SaveOptions): void {
    this.spinnerService.show();

    const reportParameterDTO = this.createAutomaticParkingReportParameters();

    this.automaticParkingReportService.exportReport(reportParameterDTO, saveOptions)
      .subscribe(savedReportFileDTO => {
        this.spinnerService.hide();
        if (saveOptions.saveReport) {
          this.router.navigate([reportsRoute]);
        } else {
          this.footer.downloadFile(savedReportFileDTO);
        }
      });
  }

  private createAutomaticParkingReportParameters(): AutomaticParkingReportParameterDTO {
    return new AutomaticParkingReportParameterDTO({
      dateRange: new DateRangeParameterDTO({
        startDate: DateTime.fromJSDate(this.filterForm.controls.startDate.value).startOf('day').toFormat('yyyy-MM-dd'),
        endDate: DateTime.fromJSDate(this.filterForm.controls.endDate.value).startOf('day').toFormat('yyyy-MM-dd')
      })
    });
  }
}
